import { Navigate, useLocation } from 'react-router-dom';

interface SearchPreservingRedirectProps {
  /** Canonical in-app path the alias now points to. */
  to: string;
}

/**
 * Redirects a legacy alias to its canonical path while keeping the query string and hash, so an old bookmark
 * such as /expenses/manager?status=pending still lands on the same filtered view. Uses `replace` so Back does not
 * bounce through the alias.
 */
export function SearchPreservingRedirect({ to }: SearchPreservingRedirectProps) {
  const { search, hash, state } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} state={state} replace />;
}

export default SearchPreservingRedirect;
